import { useModal } from '@/common/components/modal-provider/hooks/useModal';
import { BillingAddressDialogContent } from '@/features/billing-addresses/components/billing-address-dialog/BillingAddressDialog';
import type { BillingAddress, BillingAddressOwner } from '../../services/schemas';
import type { Organization } from '@/features/organizations/services/schemas';

export type BillingAddressDialogOptions =
  | { address: BillingAddress }
  | { owner?: BillingAddressOwner };

export function useBillingAddressDialog(orgs?: Organization[]) {
  const showModal = useModal();
  return (options: BillingAddressDialogOptions): Promise<boolean | undefined> =>
    showModal<boolean>({
      maxWidth: 'lg',
      className: 'max-h-[90vh] overflow-y-auto',
      content: ({ resolve }) => (
        <BillingAddressDialogContent
          address={'address' in options ? options.address : undefined}
          owner={'owner' in options ? options.owner : undefined}
          orgs={orgs}
          onSuccess={() => resolve(true)}
          onClose={() => resolve(false)}
        />
      ),
    });
}
